export default {
  isSelectedGroup: state => group =>
    state.selectedGroup && group && state.selectedGroup.id === group.id,
  isLabelGroupSelected: state =>
    state.selectedGroup ? state.selectedGroup.is_label_group : false,
  selectedGroupsCount: state => state.selectedGroupsIds.length,
  isSelectedGroupOnCurrentPage: state =>
    state.currentPageFacilitiesGroups
      .map(group => group.id)
      .includes(state.selectedGroup ? state.selectedGroup.id : null),
  selectedFacilitiesIds: state =>
    state.selectedGroupSelectedFacilities.map(({ id }) => id),
  selectedGroupSelectedFacilitiesCount: state =>
    state.selectedGroupSelectedFacilities.length,
  isAllFacilitiesGroupsSelected: state => {
    return state.allGroupsIds.every(id => state.selectedGroupsIds.includes(id));
  },
  isAllCurrentPageFacilitiesGroupsSelected: state => {
    return state.currentPageFacilitiesGroups.every(({ id }) =>
      state.selectedGroupsIds.includes(id)
    );
  },
  isAllSelectedGroupFacilitiesSelected: state => {
    return state.allSelectedGroupFacilitiesIds.every(({ id }) =>
      state.selectedGroupSelectedFacilities.map(({ id }) => id).includes(id)
    );
  },
  isAllCurrentPageSelectedGroupFacilitiesSelected: (state, getters) => {
    return state.currentPageSelectedGroupFacilities.every(({ id }) =>
      getters.selectedFacilitiesIds.includes(id)
    );
  },
  isFacilitySelected: state => facilityId =>
    state.selectedGroupSelectedFacilities.findIndex(
      ({ id }) => id === facilityId
    ) > -1,

  isFacilityGroupSelected: state => facilityId =>
    state.selectedGroupsIds.some(id => id == facilityId),

  facilitiesGroupsFiltered: state => searchValue => {
    if (!searchValue) return state.currentPageFacilitiesGroups;
    return state.currentPageFacilitiesGroups.filter(({ name }) =>
      name.toLowerCase().includes(searchValue.toLowerCase())
    );
  }
};
